import Grid from '@mui/material/Unstable_Grid2/Grid2'
import CriarEditarOrdemServico from './CriarEditarOrdemServico/CriarEditarOrdemServico'
import ListarOrdemServico from './ListarOrdemServico/ListarOrdemServico'
import { Typography } from '@mui/material'
import { Build } from '@mui/icons-material'

function OrdemServico() {
    return (
        <Grid sx={{ gap: '7px', display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Grid item sx={{
                height: '23px'
            }}>
                <Typography
                    sx={{
                        color: 'white',
                        fontSize: '20px',
                        fontWeight: 'bold'
                    }}><Build sx={{
                        height: '18px'
                    }}/> - Ordem de Serviço</Typography>
            </Grid>
            <Grid sx={{
                height: {
                    lg: '40%',
                    xl: '35%'
                }
            }}>
                <CriarEditarOrdemServico />
            </Grid>
            <ListarOrdemServico />
        </Grid>
    )
}

export default OrdemServico
